import React from 'react';
import { CreditCard } from 'lucide-react';
import { cn } from 'lib/utils';
import { PaymeIcon } from 'components/portal/PaymeIcon';
import type { PaymentMethod } from 'modules/payments/methods';
import uzcardLogo from 'assets/payment/uzcard.png';
import humoLogo from 'assets/payment/humo.png';
import clickLogo from 'assets/payment/click.svg';
import uzumLogo from 'assets/payment/uzum.svg';

const NAMES: Record<Exclude<PaymentMethod, 'card'>, string> = {
  payme: 'Payme',
  click: 'Click',
  uzum: 'Uzum',
  uzcard: 'Uzcard',
  humo: 'Humo',
  visa_mc: 'Visa / Mastercard',
};

function MethodIcon({ method }: { method: PaymentMethod }) {
  switch (method) {
    case 'payme':
      return <PaymeIcon className="h-5 w-5" />;
    case 'click':
      return <img src={clickLogo} alt="" width={20} height={20} className="h-5 w-5 shrink-0" />;
    case 'uzum':
      return <img src={uzumLogo} alt="" width={20} height={20} className="h-5 w-5 shrink-0" />;
    case 'uzcard':
      return <img src={uzcardLogo} alt="" width={15} height={20} className="h-5 w-auto shrink-0" />;
    case 'humo':
      return <img src={humoLogo} alt="" width={33} height={20} className="h-5 w-auto shrink-0 rounded-[3px]" />;
    case 'visa_mc':
    case 'card':
      return <CreditCard className="h-5 w-5 shrink-0" aria-hidden="true" />;
  }
}

/** One payment method as it reads on a checkout button: its logo and name. */
export function PaymentMethodMark({
  method,
  cardLabel,
  className,
}: {
  method: PaymentMethod;
  /** The P2P card transfer's name, in the surrounding page's language. */
  cardLabel: string;
  className?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <MethodIcon method={method} />
      <span>{method === 'card' ? cardLabel : NAMES[method]}</span>
    </span>
  );
}
